// extracted by mini-css-extract-plugin
export default {"container":"Attachments_container__Pnx6z","files":"Attachments_files__a6shw","link":"Attachments_link__DAazU"};